var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class UsersApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'users';
    }
    enc(value) {
        return encodeURIComponent(value);
    }
    baseRoute(environmentId, accountId) {
        return `${this.apiBasePath}/${this.enc(environmentId)}/${this.enc(accountId)}`;
    }
    userRoute(environmentId, accountId, userId) {
        return `${this.baseRoute(environmentId, accountId)}/${this.enc(userId)}`;
    }
    listUsers(environmentId_1, accountId_1, params_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: this.baseRoute(environmentId, accountId), params }, options));
        });
    }
    createUserWithMulti(environmentId, accountId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: this.baseRoute(environmentId, accountId),
                data,
            });
        });
    }
    resendInvite(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.userRoute(environmentId, accountId, userId)}/resend-invite`,
            });
        });
    }
    updateUser(environmentId, accountId, userId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCall({
                method: 'PUT',
                route: this.userRoute(environmentId, accountId, userId),
                data,
            });
        });
    }
    enableUser(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCall({
                method: 'POST',
                route: `${this.userRoute(environmentId, accountId, userId)}/enable`,
            });
        });
    }
    disableUser(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCall({
                method: 'POST',
                route: `${this.userRoute(environmentId, accountId, userId)}/disable`,
            });
        });
    }
    deleteUser(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCall({
                method: 'DELETE',
                route: this.userRoute(environmentId, accountId, userId),
            });
        });
    }
    forceChangePassword(environmentId, accountId, multiUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCall({
                method: 'POST',
                route: `${this.userRoute(environmentId, accountId, multiUserId)}/force-change-password`,
            });
        });
    }
}
//# sourceMappingURL=index.js.map